import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import { settingCountry } from '@/api/setting'
import addDialog from './add.dialog.vue'

const columns = [
  {
    title: '',
    enTitle: 'Country Name',
    width: 180,
    dataIndex: 'name',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Other Name',
    width: 200,
    dataIndex: 'otherName',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 200,
    dataIndex: 'operator',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Operator Email',
    width: 200,
    dataIndex: 'operator',
    slot: 'email'
  },
  {
    title: '',
    enTitle: 'Operated Time',
    width: 200,
    dataIndex: 'updateTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 60,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    SiteSearchGroup,
    addDialog
  },
  data() {
    return {
      params: {},
      dataSource: [],
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      columns: columns,
      isVisable: false,
      inputData: {}
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      journalId: 'getJournalId',
      user: 'getUser'
    })
  },
  watch: {},
  mounted() {
    this.getList()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        journalId: this.journalId,
        pageIndex: page,
        pageSize: this.pagination.size
      })

      const { list, pageIndex, pageSize, total } = await settingCountry.get(
        data
      )
      this.dataSource = list

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    add() {
      this.isVisable = true
    },
    edit(val) {
      this.inputData = val
      this.isVisable = true
    },

    cancel() {
      this.isVisable = false
    },
    handleClear() {
      this.params = {}
      this.getList()
    },
    async confirm() {
      this.isVisable = false
      this.getList()
    }
  }
}
